module.exports = {
  channelName: 'Channel name',
  simQueryPlaceholder: 'Please enter channel name',
  shippingType: 'Shipping type',
  destinationDistribution: 'Destination distribution',
  chargingMethod: 'Charging method',
  acceptableGoods: 'Acceptable goods',
  settlementWeightRoundingRules: 'Settlement weight rounding rules',
  creator: 'creator',
  bubbleCountingRatio: 'Bubble counting ratio',
  bubbleSplittingRatio: 'Bubble splitting ratio',
  multipleBoxesCalculationRules: 'Multiple boxes calculation rules',
  singleBoxLowestBillableWeight: 'Single box lowest billable weight',
  newChannel: 'New channel',
  editChannel: 'Edit channel',
  lookChannel: 'Look channel',
  weightInfo: 'Weight Info',
  channelNameNoEmpty: 'Channel name can not empty!',
  shippingTypeNoEmpty: 'Shipping type can not empty!',
  destinationDistributionNoEmpty: 'Destination distribution can not empty!',
  chargingMethodNoEmpty: 'Charging method can not empty!',
  bubbleCountingRatioNoEmpty: 'Bubble counting ratio can not empty!',
  bubbleSplittingRatioNoEmpty: 'Bubble splitting ratio can not empty!',
  singleBoxLowestBillableWeightNoEmpty: 'Single box lowest billable weight can not empty!',
  multipleBoxesCalculationRulesNoEmpty: 'Multiple boxes calculation rules can not empty!',
  settlementWeightRoundingRulesNoEmpty: 'Settlement weight rounding rules can not empty!',
  acceptableGoodsNoEmpty: 'At least select one acceptable good!',
  editExistChannel: 'A quotation has been generated by the channel. Do you want to refresh the channel information of the quotation?',
  notEditName: 'This channel has been imported into the quotation, and the channel name cannot be modified.',
  activeState: 'Active State',
  enable: 'Enable',
  disable: 'Disable',
  enableSucceed: 'Channel enabled successfully!',
  disableSucceed: 'Channel disabled successfully!',
  cannotActive: 'No data to edit.',
  exportQuotation: 'Export quotation',
  printQuotation: 'Print quotation',
  quotationValidityPeriod: 'Quotation validity period',
  quotationLabel: 'Quotation label',
  previewQuotation: 'Preview Quotation',
  longTerm: 'Long term',
  addOrder: 'add Order',
  revokeTheApprovalForm: 'Revoke the approval form',
  revokeOutboundShipment: 'Revoke Outbound Shipment',
  containerNo: 'container No',
  cannotDelete: 'It is not allowed to delete channels that have already generated quotations!'
}
